import { FilterFn } from '@tanstack/react-table';

import { NumberFilterValue } from '../components/Filters/NumberFilter';

import { minMaxFilter } from './minMaxFilter';

export const penceMinMaxFilter: FilterFn<unknown> = (row, columnId, value, addMeta) => {
  const { min, max } = (value || {}) as NumberFilterValue;
  const modifiedFilter = {
    min: typeof min === 'number' ? min * 100 : min,
    max: typeof max === 'number' ? max * 100 : max,
  };
  return minMaxFilter(row, columnId, modifiedFilter, addMeta);
};
